import React, {useEffect, useState} from "react";
import { Switch } from '@headlessui/react'
import {useTranslation} from "react-i18next";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const InputToggle = ({
    label,
    description,
    errors,
    warning,
    defaultChecked = false,
    isDisabled = false,
    onChange,
    showDetails = true,
    size = "default",
}) => {

    const { t } = useTranslation();
    const [enabled, setEnabled] = useState(defaultChecked)
    const isCompact = size === "compact";


    useEffect(() => {
        setEnabled(defaultChecked);
    }, [defaultChecked]);


    return (
        <Switch.Group
            as="div"
            className={classNames(
                showDetails ? "flex items-center justify-between" : "",
                isCompact ? "gap-4" : ""
            )}
        >
            {
                showDetails && (
                    <span className={classNames(
                        "flex-grow flex flex-col",
                        isCompact ? "mr-4" : "mr-10"
                    )}
                    >
                        <Switch.Label
                            as="span"
                            className={classNames(
                                "font-medium text-gray-900",
                                isCompact ? "text-xs" : "text-sm"
                            )}
                            passive
                        >
                            {label}
                        </Switch.Label>
                        {
                            description && (
                                <Switch.Description
                                    as="span"
                                    className={classNames(
                                        "text-gray-500",
                                        isCompact ? "text-xs" : "text-sm"
                                    )}
                                >
                                    {description}
                                </Switch.Description>
                            )
                        }

              </span>
                )
            }

            <Switch
                checked={enabled}
                onChange={(r) => {
                    if(!isDisabled){
                        setEnabled(r);
                        onChange(r);
                    }
                }}
                className={classNames(
                    enabled ? "bg-blue-1000" : "bg-gray-200",
                    "relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-1000",
                    isCompact ? "h-5 w-9" : "h-6 w-11"
                )}
            >
                <span
                    aria-hidden="true"
                    className={classNames(
                        enabled
                            ? (isCompact ? "translate-x-4" : "translate-x-5")
                            : "translate-x-0",
                        "pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200",
                        isCompact ? "h-4 w-4" : "h-5 w-5"
                    )}
                />
            </Switch>
            {errors && errors.type === 'required' && (  <p className="mt-2 text-sm text-red-600">{warning ? warning : t("app.warning.description", {field: label.toLowerCase()})}</p>)}
        </Switch.Group>
    )
};
export default InputToggle;
